<template id="feature_upload">
  <div>
    <a-upload
      list-type="picture-card"
      :file-list="argument.fileList"
      :before-upload="beforeUpload"
      @preview="handlePreview"
      @change="handleChange"
      :remove="handleRemove"
      :name="argument.key"
      :v-bind="argument.key"
      :multiple="argument.unlimit_count == true"
      :accept="argument.accept"
    >
      <div v-if="argument.fileList.length < argument.max_file_count">
        <a-icon type="plus" />
        <div class="ant-upload-text">
          {{ argument.click_name }}
        </div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <el-image fit="cover" alt="preview_image" style="width: 100%" :src="previewImage">
      </el-image>
    </a-modal>
  </div>
</template>
<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export default {
  name: "FileUpload",
  props: {
    argument: {
      type: Object,
      default: function () {
        return {
          id: 0,
          click_name: "",
          key: "",
          accept: "",
          max_file_count: 2,
          unlimit_count: false,
          fileList: [],
        };
      },
    },
  },
  data() {
    return {
      previewVisible: false,
      previewImage: "",
    };
  },
  methods: {
    isWeChatBrowser() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    isAndroidBrowser() {
      return /(Android)/i.test(window.navigator.userAgent);
    },
    isAndroidAndWeChatBrowser() {
      const userAgent = window.navigator.userAgent;
      const isAndroid = /(Android)/i.test(userAgent);
      const isHarmonyOS = /(HarmonyOS|OpenHarmony)/i.test(userAgent);
      
      if ((isAndroid || isHarmonyOS) && this.isWeChatBrowser()) {
        return true;
      }
      return false;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      console.log("handlePreview");
      console.log(file.url);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({ file, fileList }) {
      var key = this.argument.key;
      
      // 安卓环境下的文件处理优化
      if (this.isAndroidAndWeChatBrowser()) {
        fileList = fileList.map(item => {
          if (item.originFileObj && !item.url) {
            // 确保文件对象正确设置
            item.status = item.status || 'done';
            item.name = item.name || item.originFileObj.name || 'image.jpg';
            item.type = item.type || item.originFileObj.type || 'image/jpeg';
            item.size = item.size || item.originFileObj.size;
          }
          return item;
        });
      }
      
      try {
        this.$emit("fileChange", key, file, fileList);
      } finally {
        console.log();
      }
      this.argument.fileList = fileList;
      this.$forceUpdate();
      console.log(this.argument);
    },
    handleRemove(file) {
      const index = this.argument.fileList.indexOf(file);
      const newFileList = this.argument.fileList.slice();
      newFileList.splice(index, 1);
      this.argument.fileList = newFileList;
    },
    beforeUpload(file) {
      // 安卓环境下的文件验证增强
      if (this.isAndroidBrowser()) {
        const isValidType = this.argument.accept ? 
          this.argument.accept.split(',').some(type => 
            file.type.includes(type.trim().replace('.', '')) || 
            file.name.toLowerCase().endsWith(type.trim())
          ) : true;
        
        if (!isValidType) {
          this.$message.error('文件格式不支持');
          return false;
        }
        
        const isValidSize = file.size / 1024 / 1024 < 10; // 10MB限制
        if (!isValidSize) {
          this.$message.error('文件大小不能超过10MB');
          return false;
        }
      }
      return false;
    },
  },
};
</script>
